import { StatusClassNames } from "../types/StatusClassNames";
export default function initMenuToggle() {
    const button = document.querySelector('.side-nav__btn');
    const nav = document.querySelector('.side-nav');
    if (!nav || !button) {
        return;
    }
    button.addEventListener('click', () => nav.classList.toggle(StatusClassNames.active));
}
